import { addressesAndClientByIntervalIdFetch } from '../../../api/addressesAndClientByIntervalId';
import { State, StateContext } from '../base/state';
import { stateTypes } from '../constants';
import {
  SuccessState as AddressSuccessState,
  LoadingState as AddressLoadingState,
  ErrorState as AddressErrorState,
} from './addressState';
import {
  SuccessState as SelectedOwnerSuccessState,
  LoadingState as SelectedOwnerLoadingState,
  ErrorState as SelectedOwnerErrorState,
} from './selectedOwnerState';
import { groupRoomsByRelations } from '../utils';
import { searchParamKeys } from '../../../shared/configs/searchParams';
import { parseAcceptanceSlug } from '../../../shared/packages/acceptance';

export class Context extends StateContext {
  constructor(controller) {
    super({
      controller,
      InitialInstance: InitialState,
      eventType: stateTypes.addressesAndClient,
    });
  }

  async getAddressesAndClient({ intervalId, addresses, owner }) {
    this.transitionTo(new LoadingState());

    if (!addresses) {
      this.controller.addressState.transitionTo(new AddressLoadingState());
    }

    if (!owner) {
      this.controller.selectedOwnerState.transitionTo(
        new SelectedOwnerLoadingState()
      );
    }

    const { acceptanceId } = parseAcceptanceSlug(
      this.controller.searchParams.getParams(searchParamKeys.acceptance)
    );

    const result = await addressesAndClientByIntervalIdFetch({
      queryClient: this.controller.queryClient,
      params: { intervalId, acceptanceId },
    });

    if (result === 'Error') {
      this.transitionTo(
        new ErrorState({
          refetch: () => this.getAddressesAndClient(intervalId),
        })
      );

      if (!addresses) {
        this.controller.addressState.transitionTo(new AddressErrorState());
      }

      if (!owner) {
        this.controller.selectedOwnerState.transitionTo(
          new SelectedOwnerErrorState()
        );
      }
      return;
    }

    this.transitionTo(new SuccessState(result));

    if (!addresses && result.addresses) {
      this.controller.addressState.transitionTo(
        new AddressSuccessState(groupRoomsByRelations(result.addresses))
      );
    }

    if (!owner && result.client) {
      this.controller.selectedOwnerState.transitionTo(
        new SelectedOwnerSuccessState(result.client)
      );
    }
  }
}

export class InitialState extends State {
  constructor() {
    super({ status: 'idle' });
  }
}

export class LoadingState extends State {
  constructor() {
    super({ status: 'loading' });
  }
}

export class ErrorState extends State {
  constructor({ refetch }) {
    super({
      status: 'error',
      message:
        'Ошибка при получении адреса и записанного собственника. Попробуйте еще раз',
      refetch,
    });
  }
}

export class SuccessState extends State {
  constructor(value) {
    super({ status: 'success', value });
  }
}
